import { TEXT_GRAY } from '@/constants/colors';
import { VisitWorkflowStep } from '@/types/graphql';
import { renderVisitWorkflowStep, renderVisitWorkflowStepAsAction } from '@/types/visit';
import { ChipProps } from '@mui/material';
import lightBlue from '@mui/material/colors/lightBlue';

import { StatusOrOutcomeChip } from './StatusAndOutcomeChips';

const stepColorMapping: Record<VisitWorkflowStep, string> = {
    NEEDS_SERVICE: lightBlue[800],
    NEEDS_CLINICIAN: lightBlue[600],
    NEEDS_DATE: lightBlue[400],
    NEEDS_TIME: lightBlue[400],
    SCHEDULED: TEXT_GRAY,
    UNKNOWN: TEXT_GRAY,
};

export const VisitWorkflowStepChip = ({
    workflowStep,
    onClick,
    asAction = false,
    onlyPending = false,
    ...rest
}: {
    workflowStep: VisitWorkflowStep;
    onClick?: () => void;
    asAction?: boolean;
    onlyPending?: boolean;
} & Omit<ChipProps, 'label' | 'color'>) => {
    if (
        onlyPending &&
        workflowStep !== VisitWorkflowStep.NEEDS_SERVICE &&
        workflowStep !== VisitWorkflowStep.NEEDS_CLINICIAN &&
        workflowStep !== VisitWorkflowStep.NEEDS_DATE
        // TODO(jessica): incorporate needing time step when relevant
        // && workflowStep !== VisitWorkflowStep.NEEDS_TIME
    ) {
        return null;
    }
    return (
        <StatusOrOutcomeChip
            label={
                asAction
                    ? renderVisitWorkflowStepAsAction(workflowStep)
                    : renderVisitWorkflowStep(workflowStep)
            }
            color={stepColorMapping[workflowStep]}
            onClick={onClick}
            {...rest}
        />
    );
};
